import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-cookies-agreement',
  templateUrl: './cookies-agreement.component.html',
  styleUrls: ['./cookies-agreement.component.scss'],
})
export class CookiesAgreementComponent {
  @Output() public disableCookie = new EventEmitter();
  @Input() public alertText: string;
  @Input() public alertButtonText: string;
  constructor() {}

  public disableCookieAlert() {
    this.disableCookie.emit(true);
  }
}
